import { render, staticRenderFns } from "./addSidebarView.vue?vue&type=template&id=5af84c16&scoped=true&"
import script from "./addSidebarView.vue?vue&type=script&lang=js&"
export * from "./addSidebarView.vue?vue&type=script&lang=js&"
import style0 from "./addSidebarView.vue?vue&type=style&index=0&id=5af84c16&lang=scss&scoped=true&"
import style1 from "./addSidebarView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af84c16",
  null
  
)

export default component.exports